import styled from "@emotion/styled";
import React from "react";
import { parseDateString } from "../tools/utils";

const Wrapper = styled.div`
  width: 100%;
`;
const TimeTable = styled.table`
  margin: 10px 0;
  width: 80%;
  font-size: 0.85rem;
  border-collapse: collapse;
  white-space: nowrap;
  background-color: white;

  thead {
    border-top: 1px solid var(--highlight-color);
    border-left: 1px solid var(--highlight-color);
    border-right: 1px solid var(--highlight-color);
  }

  th {
    font-weight: 600;
    letter-spacing: 0.25em;
    border-left: 1px solid white;
  }

  th:first-of-type {
    border-left: none;
  }

  td,
  th {
    text-align: left;
    padding: 8px;
  }

  td {
    font-size: 0.8rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  tr td:last-of-type {
    border-right: 1px solid #d4d4d4;
  }
  tr td:first-of-type {
    border-left: 1px solid #d4d4d4;
  }
  tbody > tr {
    border-bottom: 1px solid #d4d4d4;
  }

  thead th {
    color: #ffffff;
    background: var(--highlight-color);
  }

  @media only screen and (max-width: 500px) {
    width: 100%;

    /* Force table to not be like tables anymore */
    table,
    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }

    /* Hide table headers (but not display: none;, for accessibility) */
    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    td {
      /* Behave  like a "row" */
      border: none;
      border-bottom: 1px solid #d4d4d4;
      border-left: 1px solid #d4d4d4;
      border-right: 1px solid #d4d4d4;
      position: relative;
      padding-left: 30%;
    }

    td:first-of-type {
      padding-left: 0.5rem;
      font-weight: 600;
      letter-spacing: 0.25em;
      font-family: Raleway, sans-serif;
    }

    td:before {
      /* Now like a table header */
      position: absolute;
      /* Top/left values mimic padding */
      top: 0;
      left: 0;
      width: 25%;
      white-space: nowrap;
    }

    td:first-of-type:before {
      width: 0;
      padding: 0;
    }

    thead > tr td:last-of-type {
      border-right: none;
    }
    thead > tr td:first-of-type {
      border-left: none;
    }
    tbody > tr {
      border-bottom: none;
    }

    /*
		Label the data
    You could also use a data-* attribute and content for this. That way "bloats" the HTML, this way means you need to keep HTML and CSS in sync. Lea Verou has a clever way to handle with text-shadow.
		*/

    td:nth-of-type(1):before {
      content: "";
    }
    td:nth-of-type(2):before {
      content: "Time";
    }
    td:nth-of-type(3):before {
      content: "Class";
    }
    td:nth-of-type(4):before {
      content: "Notes";
    }

    td:before {
      padding: 0.5rem;
      font-weight: 600;
      letter-spacing: 0.25em;
      font-family: Raleway, sans-serif;
      /* text-transform: uppercase; */
    }

    td {
      background-color: #fff;
    }

    td:before {
      color: #000;
      background-color: #e6e6e6;
    }

    td:first-of-type,
    td:first-of-type:before {
      color: #fff;
      background-color: var(--highlight-color);
      font-size: 1rem;
      border-left: 1px solid var(--highlight-color);
      border-right: 1px solid var(--highlight-color);
      /* text-transform: uppercase; */
    }

    tbody td {
      text-align: left;
    }
  }
`;

const table = ({ data }) => {
  return (
    <Wrapper>
      <TimeTable role="table">
        <thead>
          <tr role="row">
            <th role="columnheader">Day</th>
            <th role="columnheader">Time</th>
            <th role="columnheader">Class</th>
            <th role="columnheader">Notes</th>
          </tr>
        </thead>
        <tbody>
          {data.map(({ day, title, endDate, startDate, notes, timeStr }, i) => {
            let styles = {};
            if (i > 0 && data[i - 1].day !== day) {
              styles = { borderTop: "1px solid #D4D4D4" };
            }

            const parsedDate = parseDateString(startDate);
            const formattedStartDate = parsedDate.isFutureDate()
              ? `starts ${parsedDate.formatDate()}`
              : null;

            const completeNotes = [formattedStartDate, notes]
              .filter((n) => n)
              .join(", ");

            if (!parseDateString(endDate).isPastDate()) {
              return (
                <tr role="row" style={styles} key={i}>
                  <td role="cell">{day}</td>
                  <td role="cell">{timeStr}</td>
                  <td role="cell">{title}</td>
                  {completeNotes ? (
                    <td className="text-highlight font-semibold" role="cell">
                      {completeNotes}
                    </td>
                  ) : (
                    <td role="cell">-</td>
                  )}
                </tr>
              );
            }
            return null;
          })}
        </tbody>
      </TimeTable>
    </Wrapper>
  );
};

export default table;
